<style>
.edi-main {
	position: relative;
}
.edi-main.main-page {
	display: flex;
	flex-direction: column;
}
.foot.bottom-footer {
	height: 48px
}
.edi-main .foot ul {
	position: fixed;
	width: 100%;
	bottom: 0;
	margin: 0;
	padding: 0;
	background-color: #f8f8f8;
	border-top: 1px #d1d1d1 solid;
	z-index: 1090;
}
.edi-main .foot li {
	display: inline-block;
	width: 33.333%;
}
.edi-main .foot a {
	display: block;
	list-style: none;
	text-align: center;
	text-decoration: none;
	color: #666;
	position: relative;
	font-size: 14px;
}
.edi-main .foot a:focus {
	outline-style: none;
}
.edi-main .tabs-account,
.edi-main .tabs-home,
.edi-main .tabs-reciept {
	padding: 27px 0 1px 0;
}
.edi-main .tabs-account:after,
.edi-main .tabs-home:after,
.edi-main .tabs-reciept:after {
	content: "";
	display: block;
	position: absolute;
	background-size: 24px;
	top: 3px;
	left: 50%;
	width: 24px;
	height: 24px;
	margin-left: -12px;
	margin-bottom: 5px;
	background-repeat: no-repeat;
}
.edi-main .tabs-home:after {
	background-image: url('../assets/hometabs/home-1.png');
}
.edi-main .tabs-reciept:after {
	background-image: url('../assets/hometabs/reciept-1.png');
}
.edi-main .tabs-account:after {
	background-image: url('../assets/hometabs/account-1.png');
}
.edi-main .foot a.router-link-active {
	color: #269fa5;
}
.edi-main .foot a.tabs-home.router-link-active:after {
	background-image: url('../assets/hometabs/home-2.png');
}
.edi-main .foot a.tabs-reciept.router-link-active:after {
	background-image: url('../assets/hometabs/reciept-2.png');
}
.edi-main .foot a.tabs-account.router-link-active:after {
	background-image: url('../assets/hometabs/account-2.png');
}
.edi-main .foot li.router-link-active a {
	color: #259830;
}
</style>

<template>
<div class="edi-main main-page" :style="{ 'height': deviceHeight }">
	<transition :name="transitionName" mode="out-in">
		<router-view keep-alive></router-view>
	</transition>
	<div class="foot bottom-footer">
		<ul>
			<li><router-link to="/main/home" class="tabs-home" replace>首页</router-link></li
			><li><router-link to="/main/reciept" class="tabs-reciept" replace>单据</router-link></li
			><li><router-link to="/main/my" class="tabs-account" replace>我的</router-link></li>
		</ul>
	</div>
</div>
</template>
<!--{{{ script -->
<script>
export default {
	data () {
		return {
			transitionName: 'page-next'
		}
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Main.vue?32630f39